import { render, staticRenderFns } from "./DashboardAguardando.vue?vue&type=template&id=cac0c2d4&scoped=true"
import script from "./DashboardAguardando.vue?vue&type=script&lang=js"
export * from "./DashboardAguardando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac0c2d4",
  null
  
)

export default component.exports